<script setup lang="ts">
import Service from "@/views/playground/player/partner/planner/Service.vue";
</script>
<template>
  <service></service>
</template>
<style scoped></style>
